export default "__VITE_ASSET__Csf0dbI9__"